/**
 * Maxoptra configuration via business templates
 */
mx.Configuration = function(params) {
    this.data = {
        //
        resourcesName: 'Resource',
        resourcesPluralName: 'Resources',
        resourceInformation: 'Resource information',
        resourceGridBottomNotification: 'Select a resource to view and edit details',
        resourceDispatchingCardsTitle: 'Resources',
        resourceEmptyListNotification: 'No available Resources',
        resourceGradeName: 'Resource grade',
        resourceTypeName: 'Resource type',
        resourceSortByName: 'Sort resource cards by',
        //
        ordersName: 'Order',
        ordersPluralName: 'Orders',
        orderInformation: 'Order information',
        orderGridBottomNotification: 'Select an order to view and edit details',
        orderDispatchingCardsTitle: 'Orders',
        orderEmptyListNotification: 'No open Orders',
        orderEmptyListNotificationAddNewOrder: 'Add new Order',
        orderPriorityName: 'Order priority',
        orderTypeName: 'Order type',
        orderSortByName: 'Sort order cards by',
        //
        dispatchingFilterWindowTitle: 'Resources and orders',
        pickupLocationName: 'Target',
        pickupLocationInSortingModeName: 'Pickup location',
        defaultMapId: '2',
        defaultMapTitle: 'US',
        //
        schedulingSODAttributeName: 'Send order details to resource',
        schedulingAEAttributeName: 'Resource should acknowledge the assigned order within',
        schedulingStartedAttributeName: "Resource should show the order as 'started' within",
        schedulingRejectAttributeName: 'Resource have the right to reject incoming orders',
        //
        dateFormats: {
            shortdate: 'dd/mm', // supported: mm/dd, dd/mm
            //            fulldate: "dd/mm/yyyy",     // supported: mm/dd/yyyy, dd/mm/yyyy
            time: 'HH:mm', // supported: HH:mm (24 hour), partially supported: hh:mm (12 hour)
            //            fulldatetime: "mm/dd/yyyy hh:mm"
            weekstart: 1,
        },
        resourceCallsignEnabled: true,
        resourceIdAttributeEnabled: true,
        resourceGradeEnabled: true,
        resourcesCallsignColumnVisible: true,
        orderDropLocationEnabled: true,
        addressFormat: '{address}, {street}, {city}, {state}, {country}',
        LOC: {},
    };
    for (var i in params) {
        this.data[i] = params[i];
    }

    function localiseDateHint(string, dataloc) {
        return string
            ? string
                  .replace('HH', dataloc['mx.app.core.datetimehints']['HH']) // 24-hour hours
                  .replace('hh', dataloc['mx.app.core.datetimehints']['hh']) // 12-hour hours
                  .replace('mm', dataloc['mx.app.core.datetimehints']['mm']) // minutes
                  .replace('ss', dataloc['mx.app.core.datetimehints']['ss']) // seconds
                  .replace('dd', dataloc['mx.app.core.datetimehints']['dd']) // days
                  .replace('MM', dataloc['mx.app.core.datetimehints']['MM']) // months
                  .replace('yyyy', dataloc['mx.app.core.datetimehints']['yyyy']) // 4-digits year
                  .replace('yy', dataloc['mx.app.core.datetimehints']['yy']) // 2-digits year
            : '';
    }

    function convertJavaToExtFormat(string) {
        if (!string || !string.length) {
            return;
        }
        //        if (string.indexOf("hh") > -1) {
        //            string += " a";
        //        }
        return string
            ? string
                  .replace('HH', 'G') // 24-hour hours
                  .replace('hh', 'g') // 12-hour hours
                  .replace('mm', 'i') // minutes
                  .replace('ss', 's') // seconds
                  .replace('dd', 'd') // days
                  .replace('MM', 'm') // months
                  .replace('yyyy', 'Y') // 4-digits year
                  .replace('yy', 'y') // 2-digits year
                  .replace('aa', 'a') // am/pm
            : '';
    }

    function getExtFormatAlternatives(string) {
        var formats = [];
        formats.unique = function() {
            var r = new Array();
            o: for (var i = 0, n = this.length; i < n; i++) {
                for (var x = 0, y = r.length; x < y; x++) {
                    if (r[x] == this[i]) {
                        continue o;
                    }
                }
                r[r.length] = this[i];
            }
            return r;
        };

        var hour24 = ['G', 'H'];
        var hour12 = ['g', 'h'];
        var day = ['d', 'j'];
        var month = ['m', 'n'];
        var year4 = ['Y', 'y'];
        var year2 = ['y', 'Y'];
        var ampm = ['a', 'A'];

        for (var G in hour24) {
            if (G.length == 1) {
                // here and below: this if condition filters out possible array methods
                for (var g in hour12) {
                    if (g.length == 1) {
                        for (var d in day) {
                            if (d.length == 1) {
                                for (var m in month) {
                                    if (m.length == 1) {
                                        for (var Y in year4) {
                                            if (Y.length == 1) {
                                                for (var y in year2) {
                                                    if (y.length == 1) {
                                                        for (var a in ampm) {
                                                            if (a.length == 1) {
                                                                formats.push(
                                                                    string
                                                                        .replace('G', hour24[G])
                                                                        .replace('g', hour12[g])
                                                                        .replace('d', day[d])
                                                                        .replace('m', month[m])
                                                                        .replace('Y', year4[Y])
                                                                        .replace('y', year2[y])
                                                                        .replace('a', ampm[a])
                                                                );
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return formats.unique().join('|');
    }

    // automatically init additional date formats:
    var shortDate = this.data['dateFormats']['shortdate'];
    var raw = {};
    var alt = {};
    var hint = {};
    for (var key in this.data['dateFormats']) {
        raw[key] = this.data['dateFormats'][key];
        var extFormat = convertJavaToExtFormat(this.data['dateFormats'][key]);
        if (extFormat) {
            this.data['dateFormats'][key] = extFormat;
            alt[key] = getExtFormatAlternatives(extFormat);
            hint[key] = localiseDateHint(raw[key], this.data['LOC']);
        }
    }
    this.data['dateFormats']['dateDelimiter'] = shortDate.indexOf('.') > -1 ? '.' : '/';
    this.data['dateFormats']['raw'] = raw;
    this.data['dateFormats']['alt'] = alt;
    this.data['dateFormats']['hint'] = hint;

    // set week start:
    Ext.DatePicker.prototype.startDay = parseInt(this.data['dateFormats']['weekstart']) || 0;

    // todo: move localisation below from this file to another one
    if (MXAT && MXAT.getLocalisationMechanismVersion() >= 1.3) {
        return; // 1.3 localiastion mechanism is moved to other files (see SM application template)
    }

    // # beforerender stuff
    // # fix components that use BT values:
    Ext.override(Ext.ux.form.Spinner.TimeStrategy, {
        format: this.getDateFormat('time'),
    });

    // disable certain screens, according to bt
    if (this.data['enableScheduling'] != undefined && this.data['enableScheduling'] === false) {
        if (mx.app.page.main.DispatchSheet) {
            mx.app.page.main.DispatchSheet.navigation.disabled = true;
        }
        if (mx.app.page.main.settings && mx.app.page.main.settings.Orders) {
            mx.app.page.main.settings.Orders.navigation.disabled = true;
        }
        if (mx.app.page.main.settings && mx.app.page.main.settings.Scheduling) {
            mx.app.page.main.settings.Scheduling.navigation.disabled = true;
        }
    }
};
mx.Configuration.prototype.getTranslation = function(group, key) {
    return this.data['LOC'][group][key] || null;
};
mx.Configuration.prototype.get = function(key) {
    return this.data[key] || null;
};
mx.Configuration.prototype.getString = function(key, inlowcase, i18nkey) {
    // todo: low case
    // todo: handle i18n
    return this.data[key] || null;
};
mx.Configuration.prototype.loc = function(obj, key) {
    if (this.data.LOC[obj] && this.data.LOC[obj][key]) {
        return this.data.LOC[obj][key];
    } else {
        return null;
    }
};
mx.Configuration.prototype.getRegexpFromTimeFormat = function(time) {
    var s = time
        .replace('G', '([0-1]?\\d|2[0-3])')
        .replace('g', '(0?\\d|1[0-2])')
        .replace('i', '([0-5]\\d)')
        .replace('s', '([0-5]\\d)')
        .replace('a', '(((am)|(pm))|((AM)|(PM)))');
    return new RegExp('^' + s + '$');
};

/**
 * @param String key - one of these: "time", "shortdate", "fulldate", "fulldatetime"
 * @param String mode - "raw" to get raw format that came from server, "alt" to get alt formats string, "hint" - to get localised hint for a format
 * @return String
 */
mx.Configuration.prototype.getDateFormat = function(key, mode) {
    switch (mode) {
        case 'raw':
            return this.get('dateFormats')['raw'][key].toLowerCase() || null;
        case 'hint':
            return this.get('dateFormats')['hint'][key] || this.getDateFormat(key);
        case 'alt':
            return this.get('dateFormats')['alt'][key] || null;
        default:
            return this.get('dateFormats')[key] || null;
    }
};
/**
 * @param addrObj - address object as received from mapstraction
 * @return String address line to display on screen
 */
mx.Configuration.prototype.formatAddress = function(addrObj) {
    if (addrObj['getDescription']) {
        return this.formatAddressMap24(addrObj);
    } else {
        return this.formatAddressGoogle(addrObj);
    }
};

/**
 * @param addrObj - address object as received from mapstraction
 * @return String address line to display on screen
 */
mx.Configuration.prototype.formatAddressGoogle = function(addrObj) {
    //Comments are from KML spec
    var fieldnameMap = {
        INFO: 'AddressLine',
        //Free format address representation. An address can have more than one line. The order of the AddressLine elements must be preserved
        STREET: 'ThoroughfareName',
        //Specification of the name of a Thoroughfare (also dependant street name): street name, canal name, etc.
        CITY: 'LocalityName',
        //Locality is one level lower than adminisstrative area. Eg.: cities, reservations and any other built-up areas.
        DependentLocality: 'DependentLocalityName',
        //todo: may be its better to omit DependentLocality
        //dependent localities are Districts within cities/towns, locality divisions, postal
        //divisions of cities, suburbs, etc. DependentLocality is a recursive element, but no nesting
        //deeper than two exists (Locality-DependentLocality-DependentLocality)
        STATE: 'AdministrativeAreaName',
        COUNTY: 'AdministrativeAreaName',
        //Name of the administrative area. eg. MI in USA, NSW in Australia
        DISTRICT: 'SubAdministrativeAreaName',
        ZIP: 'PostalCodeNumber',
        COUNTRY: 'CountryNameCode',
    };
    var fields = {};
    for (var key in fieldnameMap) {
        fields[fieldnameMap[key]] = key; //STATE and COUNTY clash here but its OK
    }

    var parseAddrDetails = function(addrPartsHeap, addrDetails) {
        if (addrDetails && typeof addrDetails == 'object') {
            for (var key in addrDetails) {
                if (fields[key]) {
                    addrPartsHeap[key] = addrDetails[key];
                } else {
                    parseAddrDetails(addrPartsHeap, addrDetails[key]);
                }
            }
        }
    };

    var addrPartsHeap = [];
    parseAddrDetails(addrPartsHeap, addrObj.AddressDetails);
    if (!addrPartsHeap['LocalityName']) {
        addrPartsHeap['LocalityName'] = addrPartsHeap['DependentLocalityName'];
    }
    if (addrPartsHeap['AddressLine']) {
        addrPartsHeap['AddressLine'] = addrPartsHeap['AddressLine'].join(', ');
    }

    var r = [];

    var pushGeoInfo = function(fieldname, addrPartsHeap) {
        var v = addrPartsHeap[fieldnameMap[fieldname]];
        if (v && v.length > 0) {
            r.push(v);
        }
    };

    var addrFormat = MXBT.get('addressFormat');
    for (var i = 0; i < addrFormat.length; i++) {
        pushGeoInfo(addrFormat[i], addrPartsHeap);
    }

    return r.join(', ');
};

/**
 * @param addrObj - address object as received from mapstraction
 * @return String address line to display on screen
 */
mx.Configuration.prototype.formatAddressMap24 = function(addrObj) {
    var fieldnameToMethodMap = {
        INFO: 'getDescription',
        STREET: 'getStreet',
        CITY: 'getCity',
        COUNTY: 'getCounty',
        DISTRICT: 'getDistrict',
        STATE: 'getState',
        ZIP: 'getZip',
        COUNTRY: 'getCountry',
    };

    var r = [];

    var pushGeoInfo = function(fieldname, obj) {
        var method = fieldnameToMethodMap[fieldname];
        if (obj[method]) {
            var v = obj[method]();
            if (v && v.length > 0) {
                r.push(v);
            }
        }
    };

    var addrFormat = MXBT.get('addressFormat');
    for (var i = 0; i < addrFormat.length; i++) {
        pushGeoInfo(addrFormat[i], addrObj);
    }

    return r.join(', ');
};
/**
 * supposed, that all form controls that expect doubles will use this
 * in future there could be requirement that divider sign ("." or ",") will depend on business template
 * @param mixed value from form control, that supposed to be double
 * @return double
 */
mx.Configuration.prototype.parseDouble = function(value) {
    return parseFloat(value.toString().replace(',', '.'));
};

mx.Configuration.prototype.getPriorityStoreParams = function(fields) {
    var data = [];
    var priorities = this.get('priorities');
    for (var i in priorities) {
        if (priorities[i].name) {
            var a = [priorities[i].value, priorities[i].name];
            if (fields.length == 3) {
                a.push(priorities[i].color);
            }
            data.push(a);
        }
    }
    return {
        fields: fields,
        data: data,
    };
};
mx.Configuration.prototype.getWeekstart = function() {
    return this.data['dateFormats']['weekstart'] || 0;
};
mx.Configuration.prototype.getAllPriorityValues = function() {
    var data = [];
    var priorities = this.get('priorities');
    for (var i in priorities) {
        if (priorities[i].name) {
            data.push(priorities[i].value);
        }
    }
    return data.join(',');
};

mx.Configuration.prototype.getPriorityColor = function(v) {
    var priorities = this.get('priorities');
    for (var i in priorities) {
        if (priorities[i].value && priorities[i].value == v) {
            return priorities[i].color;
        }
    }
    return 'white';
};

/**
 * [{'key': value}, {}]
 * @param pairs
 */
mx.Configuration.prototype.getFormattedString = function(value) {
    var res = [];
    for (var p in value) {
        if (value[p] != null && value[p] !== '') {
            if (!isNaN(parseInt(p))) {
                res.push(value[p]);
            } else {
                res.push('<b>' + p + '</b>: ' + value[p]);
            }
        }
    }
    return res.join('<br/>');
};

mx.Configuration.prototype.getCurrencySign = function() {
    return this.loc('mx.app.core.termins', this.data.currencyType);
};

mx.Configuration.prototype.getWeightUnits = function() {
    return this.loc('mx.app.core.termins', this.data.weightUnits);
};

mx.Configuration.prototype.getLargeWeightUnits = function() {
    return this.loc('mx.app.core.termins', this.data.largeWeightUnits);
};
mx.Configuration.prototype.getLongDistanceUnits = function() {
    return this.loc('mx.app.core.termins', this.data.longDistanceUnits);
};

mx.Configuration.prototype.renderPrice = function(v) {
    if ((v = v * 1)) {
        return this.getCurrencySign() + v.toFixed(2);
    } else {
        return this.getCurrencySign() + '0.00';
    }
};
